import { render } from "./appuntamentiNutrizionista.vue?vue&type=template&id=1634088c&ts=true"
import script from "./appuntamentiNutrizionista.vue?vue&type=script&lang=ts"
export * from "./appuntamentiNutrizionista.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__